import console from "../../log";
// Cart mutation endpoints. Matched as a path suffix so Shopify Markets locale
// prefixes (`/en-gb/cart/add.js`) and query strings still match.
const CART_MUTATION_PATH = /\/cart\/(add|update|change|clear)(\.js)?$/;
// A bare `/cart` GET that renders theme markup rather than the cart page itself,
// e.g. Ella's side cart `/cart?view=ajax_side_cart` or Section Rendering API
// `/cart?sections=...`. Side carts inject this HTML after the mutation request
// resolves, so the checkout button they contain only exists after this request.
const CART_RENDER_PATH = /\/cart$/;
const CART_RENDER_PARAMS = ["view", "section_id", "sections"];
/**
 * Whether a storefront request may have added or re-rendered checkout buttons,
 * meaning Real ID should rescan the page for entry selectors.
 */
export function isCartRefreshRequest(url) {
    if (!url)
        return false;
    let parsed;
    try {
        parsed = new URL(url.toString(), window.location.origin);
    }
    catch (e) {
        return false;
    }
    if (parsed.origin !== window.location.origin)
        return false;
    if (CART_MUTATION_PATH.test(parsed.pathname))
        return true;
    return (CART_RENDER_PATH.test(parsed.pathname) &&
        CART_RENDER_PARAMS.some((param) => parsed.searchParams.has(param)));
}
let pendingInitialize;
/**
 * Rescan after the theme has had a chance to insert the response into the DOM.
 * Our listeners run before the theme's own response handlers, so initializing
 * synchronously scans the stale DOM. Debounced because one add-to-cart fires a
 * burst of cart requests.
 */
export function scheduleInitialize(initialize, delay = 50) {
    clearTimeout(pendingInitialize);
    pendingInitialize = setTimeout(() => {
        pendingInitialize = undefined;
        console.debug("Real ID :: cart request completed, reinitializing");
        initialize();
    }, delay);
}
